"use client";

import dynamic from "next/dynamic";

// The homepage promo is non-essential for first paint and already hidden
// during SSR, so loading it lazily keeps hero-path JS smaller.
const PromoBanner = dynamic(
  () => import("@/components/landing/PromoBanner"),
  { ssr: false }
);

export default function DeferredPromoBanner() {
  return <PromoBanner />;
}
